<div class="modal-header">
    <h5 class="modal-title" id="profileModalTitle">Edit Company Info</h5>
    <button type="button" (click)="dismiss()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
    <form [formGroup]="manageCompanyInfoForm">
        <div class="row gx-3">
            <div class="col-md-7 mb-3">
                <label for="companyName" class="form-label">Company/Organization Name<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control" id="companyName" placeholder="Company Name" formControlName="companyName" autofocus>
                <div *ngIf="companyNameCtrl.invalid && (companyNameCtrl.dirty || companyNameCtrl.touched)">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md-5 mb-3">
                <label for="employeeCount" class="form-label"># of Employees in 10 County Region</label>
                <select formControlName="employeeCount" class="form-select" aria-label="employeeCount" id="employeeCount">
                    <option *ngFor="let emp of numberOfEmployeesOptions" value="{{emp.value}}">{{emp.text}}</option>
                </select>
                <div *ngIf="employeeCountCtrl.invalid && (employeeCountCtrl.dirty || employeeCountCtrl.touched)">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md-6 mb-3">
                <label for="businessPhone" class="form-label">Business Phone<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control" id="businessPhone" placeholder="(123) 123-1234" formControlName="businessPhone" autofocus mask="(000) 000-0000">
                <div *ngIf="businessPhoneCtrl.invalid && (businessPhoneCtrl.dirty || businessPhoneCtrl.touched)">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label for="businessAddress" class="form-label">Business Address<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control" id="businessAddress" placeholder="Business Address" formControlName="businessAddress">
                <div *ngIf="businessAddressCtrl.invalid && (businessAddressCtrl.dirty || businessAddressCtrl.touched)">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md-6 mb-3">
                <label for="businessCity" class="form-label">City<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control" id="businessCity" placeholder="City" formControlName="businessCity" autofocus>
                <div *ngIf="businessCityCtrl.invalid && (businessCityCtrl.dirty || businessCityCtrl.touched)">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md-2 mb-3">
                <label for="businessState" class="form-label">State<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control" id="businessState" placeholder="State" formControlName="businessState">
                <div *ngIf="businessStateCtrl.invalid && (businessStateCtrl.dirty || businessStateCtrl.touched)">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <label for="businessZip" class="form-label">Zip<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control" id="businessZip" placeholder="Zip" formControlName="businessZip">
                <div *ngIf="businessZipCtrl.invalid && (businessZipCtrl.dirty || businessZipCtrl.touched)">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-12 mb-3">
                <label for="minorityCerts" class="form-label">Certification(s)</label>
                <mbsc-select class="mobi-input" formControlName="minorityCerts" multiple [data]="minorityCertificateTypes" [selectMultiple]="true">
                </mbsc-select>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" (click)="saveCompanyInfo()" [disabled]="isBusy" class="btn btn-sb border-lb text-strong text-uppercase m-100">Save</button>
    <button type="button" (click)="dismiss()" class="btn btn-cancel text-strong text-uppercase m-100" data-bs-dismiss="modal">Cancel</button>
</div>
